
import { reactive, toRefs } from "vue";
import Tag from "./Tag.vue";
import { FilterCondition } from "@/types/index";

export default {
  name: "FilterCondition",
  props: {
    filterCondition: Array,
  },
  emits: ['handleClear', 'handleCloseTag'],
  components: {
    Tag,
  },
  setup(props:any, context:any) {
    const data = reactive({});
    const handleClear = () => {
      context.emit("handleClear");
    };
    const handleCloseTag = (val: FilterCondition, index: number) => {
      context.emit("handleCloseTag", val, index);
    };
    return {
      ...toRefs(data),
      handleClear,
      handleCloseTag,
    };
  },
};
